export const ACTIVE_AUDIO_NODE_STORE = new WeakSet();
export const AUDIO_NODE_CONNECTIONS_STORE = new WeakMap();
export const AUDIO_NODE_STORE = new WeakMap();
export const AUDIO_PARAM_CONNECTIONS_STORE = new WeakMap();
export const AUDIO_PARAM_STORE = new WeakMap();
export const BACKUP_NATIVE_CONTEXT_STORE = new WeakMap();
export const CONTEXT_STORE = new WeakMap();
export const EVENT_LISTENERS = new WeakMap();
export const CYCLE_COUNTERS = new WeakMap();
// This clunky name is borrowed from the spec. :-)
export const NODE_NAME_TO_PROCESSOR_CONSTRUCTOR_MAPS = new WeakMap();
export const NODE_TO_PROCESSOR_MAPS = new WeakMap();
//# sourceMappingURL=globals.js.map